import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=955d80ac&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=955d80ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955d80ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('955d80ac')) {
      api.createRecord('955d80ac', component.options)
    } else {
      api.reload('955d80ac', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=955d80ac&scoped=true", function () {
      api.rerender('955d80ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chartjs/BarChart.vue"
export default component.exports